export var getConfigVideos = function getConfigVideos(state) {
  return state.configVideos;
};
export var getConfigVideo = function getConfigVideo(state, id) {
  var configVideo = getConfigVideos(state)[id] || {
    archivo: id,
    titulo: "",
    autoplay: false,
    zonaAnterior: false,
    zonaSiguiente: false,
    numVideo: 1,
    numVideosCarrusel: 1
  };
  return configVideo;
};